import { observer } from 'mobx-react';

import { useAlertStore } from '@/alert/stores/AlertStore';

import SystemAlertRow from './SystemAlertRow/SystemAlertRow';

function SystemAlerts() {
  const { alerts } = useAlertStore();

  return (
    <div>
      {alerts.map((alert) => (
        <SystemAlertRow key={alert.id} alert={alert} />
      ))}
    </div>
  );
}

export default observer(SystemAlerts);
